{
  "title": "Deltag",
  "logoPosition": "right",
  "completedHtml": "Mange tak for din tilmelding!",
  "completedBeforeHtml": "Du er allerede tilmeldt.",
  "pages": [
    {
      "name": "page1",
      "authVisibility": 2,
      "visibilityDataSource": "event_register_deadline_visible",
      "validators": [
        {
          "type": "expression",
          "text": "Tilføj mindst én deltager, hvis du ikke deltager selv.",
          "expression": "{participation_type} <> 'part_selfexcl' or {users.length} > 0"
        }
      ],
      "elements": [
        {
          "type": "text",
          "name": "question1",
          "title": "Fulde navn",
          "isRequired": true
        },
        {
          "type": "text",
          "name": "question2",
          "title": "Email",
          "description": "Hertil fremsendes beviser",
          "isRequired": true
        },
        {
          "type": "text",
          "name": "question5",
          "title": "CPR",
          "description": "Til brug ved validering af beviser & påkrævet hvis deltagende"
        },
        {
          "type": "text",
          "name": "tlf_number",
          "title": "Telefon / Mobilnummer",
          "description": "I tilfælde af at vi skal i kontakt med dig angående din deltagelse i denne"
        },
        {
          "type": "text",
          "name": "question4",
          "title": "Organisation",
          "description": "Udfyldes hvis du er en del af en organisation eller virksomhed. Gælder også eventuelle yderligere deltagere du tilmelder."
        },
        {
          "type": "comment",
          "name": "question3",
          "title": "Yderligere kommentarer"
        },
        {
          "type": "dropdown",
          "name": "participation_type",
          "title": "Deltagere",
          "description": "Vælg om du deltager selv, og tilføj eventuelle yderligere deltagere herunder",
          "isRequired": true,
          "choices": [
            {
              "value": "part_selfonly",
              "text": "Deltager selv"
            },
            {
              "value": "part_selfexcl",
              "text": "Deltager ikke selv",
              "visibleIf": "{allow_self_exclude_participation} = true"
            }
          ]
        },
        {
          "type": "paneldynamic",
          "name": "users",
          "title": "Tilføj flere deltagere",
          "description": "Tilføj flere deltagere, hvis ønsket",
          "confirmDelete": true,
          "templateElements": [
            {
              "type": "text",
              "name": "firstName",
              "title": "Fornavn",
              "isRequired": true
            },
            {
              "type": "text",
              "name": "lastName",
              "title": "Efternavn",
              "isRequired": true
            },
            {
              "type": "text",
              "name": "email",
              "title": "Email",
              "description": "Til fremsendelse af bevis",
              "isRequired": true
            },
            {
              "type": "text",
              "name": "cpr",
              "title": "CPR",
              "description": "Til brug ved validering af bevis",
              "isRequired": true
            }
          ],
          "templateTitle": "Deltager #{panelIndex}",
          "templateTabTitle": "Deltager #{panelIndex}",
          "displayMode": "tab",
          "tabAlign": "left",
          "addPanelText": "Tilføj deltager",
          "removePanelText": "Fjern",
          "panelCount": 0
        }
      ]
    },
    {
      "name": "page2",
      "visibleIf": "{catering} == 'lokation'",
      "visibilityDataSource": "event_show_catering_page",
      "elements": [
        {
          "type": "dropdown",
          "name": "catering",
          "visible": false,
          "title": "Forplejning (skjult)",
          "isRequired": true,
          "readOnly": true,
          "choices": [
            {
              "value": "selv",
              "text": "Står selv for"
            },
            {
              "value": "lokation",
              "text": "Står eventlokation for"
            },
            {
              "value": "irrelevant",
              "text": "Irrelevant"
            }
          ]
        },
        {
          "type": "checkbox",
          "name": "catering_choice",
          "visibleIf": "{catering} == 'lokation'",
          "title": "Forplejning",
          "isRequired": true,
          "choices": [
            {
              "value": "nothing",
              "text": "Ingen specielle ønsker",
              "visibleIf": "{catering_choice.length} == 0 or {catering_choice} contains 'nothing'"
            },
            {
              "value": "glutenfri",
              "text": "Glutenfri",
              "visibleIf": "{catering_choice.length} == 0 or {catering_choice} notcontains 'nothing'"
            },
            {
              "value": "hallal",
              "text": "Halal",
              "visibleIf": "{catering_choice.length} == 0 or {catering_choice} notcontains 'nothing'"
            },
            {
              "value": "vegetar",
              "text": "Vegetar",
              "visibleIf": "{catering_choice.length} == 0 or {catering_choice} notcontains 'nothing'"
            },
            {
              "value": "veganer",
              "text": "Veganer",
              "visibleIf": "{catering_choice.length} == 0 or {catering_choice} notcontains 'nothing'"
            },
            {
              "value": "laktose",
              "text": "Laktose",
              "visibleIf": "{catering_choice.length} == 0 or {catering_choice} notcontains 'nothing'"
            },
            {
              "value": "nodder",
              "text": "Nødder",
              "visibleIf": "{catering_choice.length} == 0 or {catering_choice} notcontains 'nothing'"
            }
          ]
        }
      ]
    },
    {
      "name": "page3",
      "authVisibility": 3,
      "elements": [
        {
          "type": "checkbox",
          "name": "question6",
          "title": "Godkend betingelser",
          "choices": ["Item 1"]
        }
      ]
    },
    {
      "name": "page5",
      "authVisibility": 1,
      "visibilityDataSource": "event_allow_register_others",
      "elements": [
        {
          "type": "html",
          "name": "path_module_completed_warning",
          "visibleIf": "{show_path_module_completed_warning} = true",
          "html": ""
        },
        {
          "type": "boolean",
          "name": "add_others",
          "title": "Tilføj andre deltagere end dig selv?",
          "description": "Med andre brugeres tilladelse, kan du tilføje dem til dette event.\nObs. der føres log over hvem der tilføjer.",
          "defaultValue": "false",
          "labelFalse": "Nej"
        },
        {
          "type": "boolean",
          "name": "self_participate",
          "title": "Deltager selv",
          "description": "Slå fra, hvis du kun vil tilføje andre brugere uden selv at deltage.",
          "visibleIf": "{add_others} = true and {allow_self_exclude_participation} = true",
          "defaultValue": "true",
          "labelTrue": "Ja",
          "labelFalse": "Nej"
        },
        {
          "type": "dualpanel",
          "name": "add_event_users",
          "visibleIf": "{add_others} = true",
          "title": "Tilføj andre brugere",
          "dataSource": "event_available_users"
        }
      ]
    },
    {
      "name": "page5_disabled",
      "authVisibility": 1,
      "visibilityDataSource": "event_disallow_register_others",
      "elements": [
        {
          "type": "html",
          "name": "path_module_completed_warning_disabled",
          "visibleIf": "{show_path_module_completed_warning} = true",
          "html": ""
        },
        {
          "type": "html",
          "name": "add_others_disabled_info",
          "html": "<p>Du kan tilmelde dig dette event her.</p>"
        }
      ]
    },
    {
      "name": "page6",
      "authVisibility": 1,
      "visibilityDataSource": "event_allow_cancel_24h",
      "elements": [
        {
          "type": "boolean",
          "name": "cancel_participation",
          "title": "Vil du afmelde?",
          "description": "Du kan afmelde din deltagelse indtil 24 timer før eventet starter.",
          "defaultValue": false,
          "labelFalse": "Nej",
          "labelTrue": "Ja"
        }
      ]
    }
  ],
  "completeText": "Tilmeld",
  "dataSource": "event_participate_form_data",
  "showEmptyFormSubmit": false
}
